import React from 'react';
import { Gift } from 'lucide-react';

const EventBonuses = ({ bonuses }) => {
  if (!bonuses || bonuses.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
      <div className="flex items-center gap-3 mb-4">
        <Gift className="w-6 h-6 text-yellow-500" />
        <h2 className="text-2xl font-bold text-gray-800">Event Bonuses</h2>
      </div>
      <ul className="space-y-2">
        {bonuses.map((bonus, index) => (
          <li key={index} className="flex items-start gap-2">
            <span className="text-yellow-500 mt-1">•</span>
            <span className="text-gray-700">{bonus}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EventBonuses;
